<template>
	<div :class='{"pc":!flag == true,"mobile":!flag == false}'>
		<div class="banner">
			<img v-if="!flag" src="../assets/bannar-dasai.png" alt="">
			<img class="banner-mobile" v-else src="../assets/bannar-dasai-phone.png" alt="">
		</div>
		<div class="infoBox">
			<img src="../assets/dasai.jpg" alt="">
			<div class="info">
				原农业部党组成员、国务院参事室特约研究员、中国农产品市场协会会长 张玉香，广东省农业农村厅副厅长（正厅职）陈东为品牌徽标、品牌标语、品牌包装、品牌海报、品牌短视频五组一等奖获得者颁奖。
			</div>
		</div>
		<iframe src="http://gdmpxt.org/cxds2019/showList3.html" frameborder="0" class="iframeS"></iframe>
	</div>
</template>
<script>
	export default {
		name: 'app',
		data() {
			return {
				flag: navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
			}
		},		
		methods: {
			
		},
		mounted() {
		
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.pc{
		.banner{
			position: relative;
			height: 1260px;
			img{
				position: absolute;
				left: 50%;
				margin-left: -960px;
			}
		}
		.infoBox{
			margin-top: -100px;
			padding-bottom: 100px;
			img{
				display: block;
				margin: 0 auto;
			}
			.info{
				margin: 0 auto;
				margin-top: 20px;
				margin-bottom: 80px;
				width: 800px;
				font-size: 18px;
				line-height: 34px;
				text-indent: 40px;
				text-align: justify;
			}
		}
		.iframeS{
			width:1920px;
			height:24379px;
			position: absolute;
			left: 50%;
			margin-left: -960px;
		}
		.iframeS::-webkit-scrollbar {
			display: none;
		}
	}
	.mobile {
		width: 100%;
		height: 100%;
		margin-top: 1.302083rem;
		position: relative;
		//overflow: hidden;
		.banner{
			width: 100%;
			position: relative;
			img{
				width: 100%;
				position: relative;
			}
		}
		.infoBox{
			padding: 10px;
			margin-top: -60px;
			font-size: 18px;
			line-height: 34px;
			text-align: justify;			
			img{
				width: 100%;
			}
			.info{
				text-indent: 40px;
				margin-bottom: 40px;
				margin-top: 18px;
			}
		}
		.iframeS{
			width:100%;
			height:14720px;
		}
	}
</style>
